export const gitCommit = '66edfe12'
